import { useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  TablePagination,
} from "@mui/material";

// Function to get dynamic status button color
const getStatusButtonColor = (status) => {
  switch (status) {
    case "Completed":
      return { backgroundColor: "green", color: "white" };
    case "In Progress":
      return { backgroundColor: "purple", color: "white" };
    case "Pending":
      return { backgroundColor: "orange", color: "white" };
    default:
      return { backgroundColor: "gray", color: "white" };
  }
};

// Reusable Table Component
const ReusableTable = ({ columns, data }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  

  return (
    <Box>
      <TableContainer>
        <Table>
          {/* Table Head */}
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell key={column.id} sx={{ fontWeight: "bold", color: "black", textAlign: "center" }}>
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          {/* Table Body */}
          <TableBody>
            {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
              <TableRow key={index}>
                {columns.map((column) => (
                  <TableCell key={column.id} sx={{ textAlign: "center" }}>
                    {column.id === "status" ? (
                      <Button
                        variant="contained"
                        sx={{
                          backgroundColor: getStatusButtonColor(row[column.id]).backgroundColor,
                          color: getStatusButtonColor(row[column.id]).color,
                          borderRadius: "5px",
                          padding: "8px",
                          textTransform: "none",
                        }}
                      >
                        {row[column.id]}
                      </Button>
                    ) : (
                      row[column.id]
                    )}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      <TablePagination
        rowsPerPageOptions={[5, 10, 20]}
        component="div"
        count={data.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Box>
  );
};

export default ReusableTable;
